import { render, staticRenderFns } from "./bmi.vue?vue&type=template&id=daa2c2a8&scoped=true&"
import script from "./bmi.vue?vue&type=script&lang=js&"
export * from "./bmi.vue?vue&type=script&lang=js&"
import style0 from "./bmi.vue?vue&type=style&index=0&id=daa2c2a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa2c2a8",
  null
  
)

export default component.exports